// Actions
import {
  SET_FEMALE,
  SET_MALE,
  SET_OTHER_THIRD_GENDER,
  SET_GENDER_STATE
} from "../actionTypes/gender.actionTypes";

// Classes
import { GenderReducerState } from "../classes/gender.classes";

export interface ISetGenderAction {
  type: string;
  payload: boolean;
}

export function setFemale(female: boolean): ISetGenderAction {
  return { type: SET_FEMALE, payload: female };
}

export function setMale(male: boolean): ISetGenderAction {
  return { type: SET_MALE, payload: male };
}

export function setOtherThirdGender(
  otherThirdGender: boolean
): ISetGenderAction {
  return { type: SET_OTHER_THIRD_GENDER, payload: otherThirdGender };
}

export interface ISetGenderStateAction {
  type: string;
  payload: GenderReducerState;
}

export function setGenderState(
  state: GenderReducerState
): ISetGenderStateAction {
  return { type: SET_GENDER_STATE, payload: state };
}
try {
    // @ts-ignore
    setFemale.displayName = "setFemale";
    // @ts-ignore
    setFemale.__docgenInfo = { "description": "", "displayName": "setFemale", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setFemale"] = { docgenInfo: setFemale.__docgenInfo, name: "setFemale", path: "src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setFemale" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setMale.displayName = "setMale";
    // @ts-ignore
    setMale.__docgenInfo = { "description": "", "displayName": "setMale", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setMale"] = { docgenInfo: setMale.__docgenInfo, name: "setMale", path: "src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setMale" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setOtherThirdGender.displayName = "setOtherThirdGender";
    // @ts-ignore
    setOtherThirdGender.__docgenInfo = { "description": "", "displayName": "setOtherThirdGender", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setOtherThirdGender"] = { docgenInfo: setOtherThirdGender.__docgenInfo, name: "setOtherThirdGender", path: "src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setOtherThirdGender" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGenderState.displayName = "setGenderState";
    // @ts-ignore
    setGenderState.__docgenInfo = { "description": "", "displayName": "setGenderState", "props": { "female": { "defaultValue": null, "description": "", "name": "female", "required": false, "type": { "name": "boolean" } }, "male": { "defaultValue": null, "description": "", "name": "male", "required": false, "type": { "name": "boolean" } }, "otherThirdGender": { "defaultValue": null, "description": "", "name": "otherThirdGender", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setGenderState"] = { docgenInfo: setGenderState.__docgenInfo, name: "setGenderState", path: "src/shared/containers/Filter/Demographics/Gender/actionCreators/gender.actionCreators.ts#setGenderState" };
}
catch (__react_docgen_typescript_loader_error) { }